export default __webpack_public_path__ + "static/media/d_wdt_c_3_4.771863db.mp3";